import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/dashboard.css";
import "./assets/css/dashboard-responsive.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/role-permission.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./Layout";

import Protected from "./Protected";
import Dashboard from "./Component/Home/Dashboard";
import Login from "./Component/Login/Login";

import Students from "./Component/Users/Students";
import StudentAdd from "./Component/Users/StudentAdd";

import Banner from "./Component/Banner/Banner";
import BannerAdd from "./Component/Banner/BannerAdd";
import BannerEdit from "./Component/Banner/BannerEdit";
import PageNotFound from "./Component/404/PageNotFound";
import NotificationList from "./Component/Notification/NotificationList";
import NotificationAdd from "./Component/Notification/NotificationAdd";
import NotificationEdit from "./Component/Notification/NotificationEdit";
import Library from "./Pages/Library/Library.js";
import AddLibrary from "./Pages/Library/AddLibrary.js";
import EditLibrary from "./Pages/Library/EditLibrary.js";
import ViewLibrary from "./Pages/Library/ViewLibrary.js";
import LibrarySlots from "./Pages/Library/LibrarySlots.js";
import LibrarySlots2 from "./Pages/Library/LibrarySlots2.js";
import LibraryBookingList from "./Pages/Orders/LibraryBookingList.js";
import ViewStudent from "./Pages/User/ViewStudent.jsx";
import OfflineBookings from "./Pages/Orders/OfflineBookings.js";
import OnlineBookings from "./Pages/Orders/OnlineBookings.js";
import ForgetPassword from "./Component/Login/ForgetPassword.js";
import PaymentReport from "./Pages/Payment/PaymentReport.jsx";
import ReferralList from "./Pages/Referal/ReferralList.js";
import Budget from "./Pages/Budget/Budget.js";
import LibraryBookingListC from "./Pages/Orders/LibraryBookingList copy.js";
import OwnerCouponList from "./Pages/Coupons/OwnerCouponList.js";
import OwnerCouponAdd from "./Pages/Coupons/OwnerCouponAdd.js";
import OwnerCouponEdit from "./Pages/Coupons/OwnerCouponEdit.js";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />
          {/* <Route path="/forget-password" element={ <ForgetPassword/>} /> */}
          {/* <Route path="/reset-password" element={ <ResetPassword/>} /> */}

          <Route path="/" element={<Layout />}>
            <Route index element={<Protected Component={Dashboard} />} />
            <Route path="banner" element={<Protected Component={Banner} />} />
            <Route
              path="banner-add"
              element={<Protected Component={BannerAdd} />}
            />
            <Route
              path="banner-edit/:id"
              element={<Protected Component={BannerEdit} />}
            />
            <Route
              path="students"
              element={<Protected Component={Students} />}
            />
            <Route
              path="student-add"
              element={<Protected Component={StudentAdd} />}
            />

            <Route
              path="notifications"
              element={<Protected Component={NotificationList} />}
            />
            <Route
              path="notifications/create"
              element={<Protected Component={NotificationAdd} />}
            />
            <Route
              path="notifications/edit/:id"
              element={<Protected Component={NotificationEdit} />}
            />

            {/* PIDIGIHUB ROUTES STARTED FROM HERE */}
            {/* <Route
              path="library"
              element={<Protected Component={Library} />}
            />
            <Route
              path="library/add"
              element={<Protected Component={AddLibrary} />}
            /> */}
            <Route
              path="library"
              element={<Protected Component={EditLibrary} />}
            />
            <Route
              path="slots1"
              element={<Protected Component={LibrarySlots} />}
            />
            <Route
              path="slots"
              element={<Protected Component={LibrarySlots2} />}
            />

            <Route
              path="orders/library-bookings"
              element={<Protected Component={LibraryBookingList} />}
            />
            <Route
              path="orders/library-bookings-2"
              element={<Protected Component={LibraryBookingListC} />}
            />
            <Route
              path="orders/offline-bookings"
              element={<Protected Component={OfflineBookings} />}
            />
            <Route
              path="orders/online-bookings"
              element={<Protected Component={OnlineBookings} />}
            />
            <Route
              path="student/:id"
              element={<Protected Component={ViewStudent} />}
            />
            <Route
              path="orders/payment-report"
              element={<Protected Component={PaymentReport} />}
            />
            <Route
              path="referrals"
              element={<Protected Component={ReferralList} />}
            />
            <Route
              path="budget"
              element={<Protected Component={Budget} />}
            />
            <Route
              path="coupons"
              element={<Protected Component={OwnerCouponList} />}
            />
            <Route
              path="coupons/add"
              element={<Protected Component={OwnerCouponAdd} />}
            />
            <Route
              path="coupons/edit/:id"
              element={<Protected Component={OwnerCouponEdit} />}
            />
          </Route>
          <Route path="*" element={<PageNotFound />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />

        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
